import React, { useEffect } from "react";
import { Routes, Route, Outlet, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Home";
import History from "./components/History";
import VisionMission from "./components/VisionMission";
import Gallery from "./components/Gallery";
import CNCouncil from "./components/CNCouncil";
// import Business from "./components/Business";
import Contactus from "./components/Contactus";
import MemberPage from "./components/Member";
import Footer from "./components/Footer";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import CncElectionPortal from "./components/CncElectionPortal";

function ScrollToHash() {
    const { hash } = useLocation();
    useEffect(() => {
        if (!hash) return;
        const id = hash.slice(1);
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, [hash]);
    return null;
}
function Layout() {
    const { pathname } = useLocation();
    const hideMainHeader = pathname.toLowerCase() === "/cnclogin";

    return (
        <>
            {!hideMainHeader && <Header />}
            <ScrollToHash />
            <main>
                <Outlet />
            </main>
        </>
    );
}
function LandingPage() {
    return (
        <>
            <Home />
            <History />
            <VisionMission />
            <Gallery />
            <CNCouncil />
            {/* <Business /> */}
            <Contactus />
            <Footer />
        </>
    );
}

function NotFound() {
    return <div style={{ padding: 24 }}>Page not found</div>;
}

export default function App() {
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path="/" element={<LandingPage />} />
                <Route path="member" element={<MemberPage />} />
                <Route path="CNCLogin" element={<CncElectionPortal />} />
                <Route path="cnc-election" element={<CncElectionPortal />} />
                <Route path="privacy" element={<Privacy />} />
                <Route path="terms" element={<Terms />} />
                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    );
}
 
